module.exports = __webpack_public_path__ + "static/media/tutorial.d3e8519b.png";